import { useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen } from '../experiments/useExperiment';
import { useCurrentStep } from './useCurrentStep';
import { Tracker } from '../store/tracking/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Data } from 'signup-constants/signupData/Data';
import { useSelector, useDispatch } from 'react-redux';
import { getGuessedDataBreeze } from '../store/guessed-prefill/selectors';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
export const useSearchAndPrefillExperiment = () => {
  const {
    currentStep
  } = useCurrentStep();
  const dispatch = useDispatch();
  const companyName = useSelector(state => getSignupDataValue(state, Data.CompanyName));
  const guessedCompanyName = useSelector(getGuessedDataBreeze(Data.CompanyName));
  const {
    isAssignedToSpecificVariant: isAssignedToACQ172Variant
  } = useExperiment(ExperimentKeys.ACQ0172, TrackWhen.never);
  const isAssignedToACQ172VariantB = isAssignedToACQ172Variant(ExperimentParameterGroup.Variant_B);
  const isInPrefillExperiment = isAssignedToACQ172VariantB;
  const trackCompanyNameChanged = () => {
    if (isInPrefillExperiment) {
      if (companyName !== guessedCompanyName) {
        dispatch(Tracker.signupInteraction('breeze-company-name-prefilled-changed'));
      }
    }
  };
  const searchAndPrefillHelperText = isInPrefillExperiment ? `views.${currentStep}.searchAndPrefillHelperText` : `views.${currentStep}.help`;
  return {
    isAssignedToACQ172VariantB,
    searchAndPrefillHelperText,
    trackCompanyNameChanged
  };
};